// extracted by mini-css-extract-plugin
export default {"sRoundButton":"RectangleButtonSecond_sRoundButton__IUhYM"};